import React, { useState, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
  updateData,
} from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import { useNavigate, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import { AiOutlineEye } from "react-icons/ai";
import { FaCheck, FaTimes } from "react-icons/fa";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const KYCList = () => {
  const [pending, setPending] = useState(true);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [selectedKYC, setSelectedKYC] = useState(null);

  let image_baseurl = `${endPoints.apiBaseUrl}`;

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchKYCData();
  }, []);

  const fetchKYCData = async () => {
    let url = `${endPoints.api.GET_KYC_LIST}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        console.log("data", response);
        setIsLoading(false);
        if (response.status === "success" || response.status === 200) {
          setRows(response.data || []);
          setPending(false);
        } else {
          ErrorToast(response?.message || "Failed to fetch KYC data");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast("An error occurred while fetching KYC data");
      });
  };

  const handlePreviewClose = () => {
    setShowPreviewModal(false);
    setSelectedKYC(null);
  };

  const handlePreviewShow = (kycData) => {
    setSelectedKYC(kycData);
    setShowPreviewModal(true);
  };

  const handleKYCAction = async (userId, action) => {
    // action: "pass" or "fail"
    setIsLoading(true);
    const payload = {
      userId: userId,
      status: action,
    };

    try {
      const response = await updateData(
        endPoints.api.UPDATE_KYC_STATUS,
        payload,
      );
      setIsLoading(false);

      if (response?.status === 200 || response.data?.status === "success") {
        SuccesToast(
          action === "pass"
            ? "KYC approved successfully"
            : "KYC rejected successfully",
        );
        fetchKYCData(); // Refresh the list
      } else {
        ErrorToast(response?.data?.message || "Failed to update KYC status");
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
      ErrorToast("An error occurred while updating KYC status");
    }
  };

  const approveKyc = async (id) => {
    try {
      let url = `${endPoints.api.UPDATE_KYC_STATUS}/?id=${id}&status=Approved`;
      // let data = {
      //   id: id,
      //   status: "Approved",
      // };
      setIsLoading(true);
      let response = await updateData(url);
      setIsLoading(false);
      if (response?.data?.status == "success") {
        SuccesToast(response?.data?.message);
        fetchKYCData(); // Refresh the list
      } else {
        ErrorToast(response?.data?.message);
      }
    } catch (Err) {
      console.log(Err);
    } finally {
      setIsLoading(false);
    }
  };

  const rejectKyc = async (id) => {
    try {
      let url = `${endPoints.api.UPDATE_KYC_STATUS}?id=${id?.id}&status=Rejected`;
      // let data = {
      //   id: id?.id,
      //   status: "Rejected",
      // };
      setIsLoading(true);
      let response = await updateData(url);
      setIsLoading(false);
      console.log("reject response", response);
      if (response?.data?.status == "success") {
        SuccesToast(response.data.message);
        fetchKYCData(); // Refresh the list
      } else {
        ErrorToast(response.data.message);
      }
    } catch (Err) {
      console.log(Err);
    } finally {
      setIsLoading(false);
    }
  };

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "/images/placeholder.png";
    if (imagePath.startsWith("http")) return imagePath;
    return `${image_baseurl}${imagePath}`;
  };

  // {
  //           "id": 1,
  //           "idUser": 3189,
  //           "selfie": "documnet/1773841409454_bannerpng",
  //           "front": "documnet/1773841418904_bannerpng",
  //           "back": "documnet/1773841426053_bannerpng",
  //           "status": "Pending",
  //           "doc_type": null,
  //           "createdOn": "2026-03-18T14:05:07.000+00:00"
  //       },

  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                    KYC List
                  </h3>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-12">
                  <TableContainer component={Paper}>
                    <Table
                      sx={{ minWidth: 500 }}
                      aria-label="custom pagination table"
                    >
                      <TableHead>
                        <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                          <TableCell
                            style={{
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            User ID
                          </TableCell>
                          <TableCell
                            style={{
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            Selfie
                          </TableCell>
                          <TableCell
                            style={{
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            Doc Front
                          </TableCell>
                          <TableCell
                            style={{
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            Doc Back
                          </TableCell>
                          <TableCell
                            style={{
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            Status
                          </TableCell>
                          <TableCell
                            style={{
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            Preview
                          </TableCell>
                          <TableCell
                            style={{
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            Actions
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(rowsPerPage > 0
                          ? rows.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage,
                            )
                          : rows
                        ).map((row, index) => (
                          <TableRow key={row.id || index}>
                            <TableCell>{row.idUser}</TableCell>
                            <TableCell>
                              <img
                                src={`${endPoints?.apiBaseUrl}${row?.selfie}`}
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  objectFit: "cover",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                }}
                                onClick={() => handlePreviewShow(row)}
                              />
                            </TableCell>
                            <TableCell>
                              <img
                                src={`${endPoints?.apiBaseUrl}${row?.front}`}
                                alt="Doc Front"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  objectFit: "cover",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                }}
                                onClick={() => handlePreviewShow(row)}
                              />
                            </TableCell>
                            <TableCell>
                              <img
                                src={`${endPoints?.apiBaseUrl}${row?.back}`}
                                alt="Doc Back"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  objectFit: "cover",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                }}
                                onClick={() => handlePreviewShow(row)}
                              />
                            </TableCell>
                            <TableCell>{row?.status}</TableCell>
                            <TableCell>
                              <Button
                                variant="info"
                                size="sm"
                                onClick={() => handlePreviewShow(row)}
                              >
                                <AiOutlineEye size={18} /> Preview
                              </Button>
                            </TableCell>
                            {row?.status === "Pending" ? (
                              <TableCell>
                                <Button
                                  variant="success"
                                  size="sm"
                                  onClick={() => approveKyc(row?.id)}
                                  style={{ marginRight: "5px" }}
                                  // disabled={row.status === "approved" || row.status === "pass"}
                                >
                                  <FaCheck /> Pass
                                </Button>
                                <Button
                                  variant="danger"
                                  size="sm"
                                  onClick={() => rejectKyc(row)}
                                  // disabled={row.status === "rejected" || row.status === "fail"}
                                >
                                  <FaTimes /> Reject
                                </Button>
                              </TableCell>
                            ) : (
                              <TableCell>
                                <span
                                  style={{
                                    color:
                                      row.status === "Approved"
                                        ? "green"
                                        : "red",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {row.status}
                                </span>
                              </TableCell>
                            )}
                          </TableRow>
                        ))}

                        {emptyRows > 0 && (
                          <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={8} />
                          </TableRow>
                        )}
                      </TableBody>
                      <TableFooter>
                        <TableRow>
                          <TablePagination
                            rowsPerPageOptions={[
                              5,
                              10,
                              25,
                              { label: "All", value: -1 },
                            ]}
                            colSpan={8}
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            SelectProps={{
                              inputProps: {
                                "aria-label": "rows per page",
                              },
                              native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                          />
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Preview Modal */}
      <Modal
        show={showPreviewModal}
        onHide={handlePreviewClose}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>KYC Documents Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedKYC && (
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12 text-center mb-4">
                  <h6 className="mb-2">Selfie</h6>
                  {selectedKYC.selfie ? (
                    <img
                      src={`${endPoints?.apiBaseUrl}${selectedKYC?.selfie}`}
                      alt="Selfie"
                      style={{
                        width: "100%",
                        maxHeight: "500px",
                        objectFit: "contain",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        padding: "5px",
                      }}
                    />
                  ) : (
                    <p style={{ color: "#999" }}>No selfie available</p>
                  )}
                </div>
                <div className="col-md-12 text-center mb-4">
                  <h6 className="mb-2">Document Front</h6>
                  {selectedKYC.front ? (
                    <img
                      src={`${endPoints?.apiBaseUrl}${selectedKYC?.front}`}
                      alt="Document Front"
                      style={{
                        width: "100%",
                        maxHeight: "500px",
                        objectFit: "contain",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        padding: "5px",
                      }}
                    />
                  ) : (
                    <p style={{ color: "#999" }}>No document front available</p>
                  )}
                </div>
                <div className="col-md-12 text-center mb-4">
                  <h6 className="mb-2">Document Back</h6>
                  {selectedKYC.back ? (
                    <img
                      src={`${endPoints?.apiBaseUrl}${selectedKYC?.back}`}
                      alt="Document Back"
                      style={{
                        width: "100%",
                        maxHeight: "500px",
                        objectFit: "contain",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        padding: "5px",
                      }}
                    />
                  ) : (
                    <p style={{ color: "#999" }}>No document back available</p>
                  )}
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handlePreviewClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default KYCList;
